import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // SHA-256 해시 함수 (간단한 구현)
  const sha256 = async (message) => {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  };

  // 암호화된 비밀번호 (gksaor01!를 SHA-256으로 해시한 값)
  const hashedPassword = '75e8d20b525bd8a1236750ff40148729874f94a980386845124841fe6fded27a';

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // 입력된 비밀번호를 해시화
      const inputHash = await sha256(password);
      
      // 해시된 비밀번호 비교
      if (inputHash === hashedPassword) {
        onLogin(true);
        setError('');
      } else {
        setError('비밀번호가 올바르지 않습니다.');
        setPassword('');
      }
    } catch (error) {
      setError('인증 처리 중 오류가 발생했습니다.');
      setPassword('');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>비전검사시스템<br />유틸리티</h1>
          <p>시스템에 접근하려면 비밀번호를 입력하세요</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력하세요"
              autoFocus
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="login-btn">
            🔐 로그인
          </button>
        </form>
        
        <div className="login-footer">
          <p>© 2024 비전검사시스템. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;